import axios from 'axios'     
import { Dialog } from 'vant';
import router from './../router'
import store from '../store/index' // 引入Vuex
export const h5url = '/'

let baseURL = 'https://api.tbo000.com'
 
sessionStorage.setItem("baseURL",baseURL)

if(process.env.NODE_ENV=="development"){
  baseURL=''
}

let config = {
    baseURL: baseURL,
    timeout: 30000      
}
const _axios = axios.create(config)

_axios.interceptors.request.use(
    config => {
        let token = store.state.token || sessionStorage.getItem('token') || '';
        config.headers.Authorization = 'Bearer ' + token;  
        return config;
    },
    err => Promise.reject(err)
);

_axios.interceptors.response.use(
    res => {
        if (res.data.code === 401) {
            Dialog.alert({
                title: '认证失败',
                message: '您的账号登陆过期，请重新登陆',
              }).then(() => {
                // 登出时清空所有登录状态
                store.commit('clearLoginState');
                router.replace('/login');
              });
        }
        return res;
    },
    err => {
        if (err) {

        }
        return Promise.reject(err);
    }
);

const http = {
    get(url = '', params = {}) {
        return new Promise((resolve, reject) => {
            _axios({
                url,
                params,
                headers: { 'Content-Type': 'application/json;charset=UTF-8' },
                method: 'GET'
            }).then(res => {
                resolve(res.data)
                return res
            }).catch(error => {
                reject(error)
            })
        })
    },
    post(url = '', params = {}) {
        if (url == '/api/register' || url == '/api/login_pc') {
            sessionStorage.setItem("baseURL", baseURL)
        }
        return new Promise((resolve, reject) => {
            _axios({
                url,
                data: params,
                headers: { 'Content-Type': 'application/json;charset=UTF-8' },
                method: 'POST'
            }).then(res => {
                resolve(res.data)
                return res
            }).catch(error => {
                reject(error)
            })
        })
    }
}

export default http


// WEBPACK FOOTER //
// ./src/http/http.js